var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"variety-image"},[_c('HeadedContainer',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$ml.get("Image"))+" ")]},proxy:true}])},[_c('ImageInput',{class:{
        'disabled': (_vm.$store.getters['crop/base'].owner == 0)
      },attrs:{"value":_vm.image},on:{"input":_vm.uploadFile}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }